import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    backgroundColor: 'white',
    padding: '1.5rem 2rem 0.5rem 2rem',
    borderRadius: '4px',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
  },
  container: {
    width: '50%',
    height: '32rem',
    fontSize: '16px',
  },
}));

export default useStyles;
